"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HorizontalRule_1 = require("./HorizontalRule");
exports.default = HorizontalRule_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/HorizontalRule/index.js
// module id = 1771
// module chunks = 8